import { Group, Loader, Text } from '@mantine/core';
import { use, useEffect, useState } from 'react';
import Markdown from 'react-markdown';

import classes from './StreamingMessage.module.css';
import { ChatContext } from '#components/chat/contexts/ChatContext';

export function StreamingMessage() {
  const { streamingMessage } = use(ChatContext);
  const [text, setText] = useState<string[]>([]);

  useEffect(() => {
    if (!streamingMessage) {
      return;
    }

    streamingMessage
      .on('message', () => {
        setText([]);
      })
      .on('content', (msg) => {
        setText((prev) => [...prev, msg]);
      });

    return () => {
      setText([]);
    };
  }, [streamingMessage]);

  if (!text.length) {
    return (
      <Group>
        <Loader color="white" size="sm" type="dots" />
        <Text fs="italic" span>
          Thinking...
        </Text>
      </Group>
    );
  }

  return (
    <div className={classes.streamingMessage}>
      <Markdown>{text.join('')}</Markdown>
      <Loader color="white" size="xs" type="oval" />
    </div>
  );
}
